// extracted by mini-css-extract-plugin
export default {"text-between-dividers":"templates-register-module__text-between-dividers"};